// eslint-disable-next-line import/prefer-default-export
export const selectReports = (state) => state.reports;
